<template>
  <div class="plan-wrap" :class="{ 'single': single, 'selected': selectedProduct === productName }">
    <button
      v-if="isButton"
      class="plain plan-btn"
      @click="clicked"
      :data-cy="'btn--' + products[productName].name + '-plan'"
      :aria-ariaLabel="ariaLabel"></button>
    <div class="box-wrap"
      :class="{ 'selected': selectedProduct === productName }"
      :data-cy="'group--' + products[productName].name + '-plan'">
      <div class="select-box" :class="{ 'selected': selectedProduct === productName, 'card': card, 'ribbon': ribbon }">
        <div class="radio-check"></div>
        <div class="plan-content">
          <div class="plan-info">
            <div v-show="showPrices">
              <p v-if="pricingValues[productName].savings" class="bold save">
                <span v-if="ribbonText" class="ribbon-text">{{ribbonText}}</span>
                SAVE {{pricingValues[productName].savings.total.percent}}%
              </p>
              <h4>{{products[productName].title}}</h4>
              <p class="monthly-price"><span class="number bold">{{'$' + pricingValues[productName].monthlyPrice}}</span>/month</p>
              <p v-if="billingCopy(productName)" class="fine-print">{{'$' + pricingValues[productName].chargePrice + ' ' + billingCopy(productName)}}</p>
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
      <div v-if="bonus" class="bonus">
        <slot name="bonus"></slot>
      </div>
    </div>
    <img v-if="bonus" class="hide-bear" src="./images/remembear-hide.svg">
  </div>
</template>

<script>
import products from '@/data/product-details.js'

export default {
  name: 'plan-box',
  props: {
    card: Boolean,
    single: Boolean,
    sale: Object,
    showCoupon: Boolean,
    productName: String,
    selectedProduct: String,
    pricingValues: Object,
    isButton: Boolean,
    bonus: Boolean,
    ribbon: Boolean,
    ribbonText: String,
    showPrices: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      products
    }
  },
  computed: {
    ariaLabel: function () {
      return (
        (this.selectedProduct === this.productName ? 'Current Selection. ' : '') +
        this.products[this.productName].title + ': ' +
        '$' + this.pricingValues[this.productName].chargePrice +
        ' ' + this.billingCopy(this.productName)
      )
    },
    coupon: function () {
      return this.pricingValues[this.productName].coupon || null
    },
    isCouponProduct: function () {
      return !!this.coupon &&
        this.sale.couponProducts[this.coupon.code] === this.productName
    },
    showSaleDecor: function () {
      return this.sale.isLive &&
        this.isCouponProduct &&
        this.showCoupon
    }
  },
  methods: {
    clicked: function () {
      if (this.isButton) {
        this.$emit('clicked', this.productName)
      }
    },
    billingCopy: function (product) {
      let billingCopy = ''
      const discountPricing = (this.sale.isLive && this.coupon && this.sale.couponProducts[this.coupon.code] === product)
      const priceDifference = this.pricingValues[this.productName].chargePrice < this.pricingValues[this.productName].regularPrice
      if (discountPricing || priceDifference) {
        billingCopy = 'billed for the first year'
      } else if (this.products[product].renews) {
        const cycle = this.products[product].cycleMonths > 1 ? this.products[product].cycleMonths + ' months' : 'month'
        billingCopy = 'billed every ' + cycle
      } else {
        billingCopy = 'billed once'
      }
      return billingCopy
    }
  }
}
</script>

<style scoped lang="stylus" src="./plan-box.styl" >
